import { AbbrApi, FolderArrowDown } from "@gravity-ui/icons";
import { IconData } from "@gravity-ui/uikit";
import { DewuLogo, GoatLogo, PoizonLogo, ShihuoLogo } from "src/components";

interface ServiceCardInfo {
  title: string;
  icon: IconData;
  order: number;
}

export const serviceCardInfo: Record<string, ServiceCardInfo> = {
  "product-storage-service": {
    title: "Product storage API",
    icon: AbbrApi,
    order: 0,
  },
  "exporter-master-service": {
    title: "Система выгрузок",
    icon: FolderArrowDown,
    order: 1,
  },
  "dewu-service": {
    title: "Dewu API",
    icon: DewuLogo,
    order: 2,
  },
  "poizon-ru-service": {
    title: "Poizon API",
    icon: PoizonLogo,
    order: 3,
  },
  "goat-parser-service": {
    title: "Goat API",
    icon: GoatLogo,
    order: 4,
  },
  "shihuo-api-service": {
    title: "Shihuo API",
    icon: ShihuoLogo,
    order: 5,
  },
};
